import { Box } from '@material-ui/core';
import { BorrowerOnboardingDetails } from '@nemuru-eng/js-api-client';

import { DocumentIdSection } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/DocumentIdSection';
import { FamiliarSituation } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/FamiliarSituation/FamiliarSituation';
import { MainResidence } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/MainResidence/MainResidence';
import { ProfessionalDetailsSection } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/ProfessionalDetailsSection/ProfessionalDetailsSection';
import { BorrowerInvitationSection } from '@/components/modules/KYC/KYCLoan/shared/BorrowerInvitationSection/BorrowerInvitationSection';

interface BorrowerKYCProps {
  loanId: string;
  agentId: string;
  onboardingDetails: BorrowerOnboardingDetails;
  editModeAllowed?: boolean;
}

export const BorrowerKYC = ({ loanId, agentId, editModeAllowed, onboardingDetails }: BorrowerKYCProps) => {
  const borrowerInvitation = 'invitation' in onboardingDetails ? onboardingDetails.invitation : null;

  return (
    <>
      <BorrowerInvitationSection borrowerInvitation={borrowerInvitation} editModeAllowed={editModeAllowed} />
      <Box mt={3} />
      <DocumentIdSection loanId={loanId} onboardingDetails={onboardingDetails} editModeAllowed={editModeAllowed} />
      <Box mt={3} />
      <MainResidence loanId={loanId} onboardingDetails={onboardingDetails} editModeAllowed={editModeAllowed} />
      <Box mt={3} />
      <FamiliarSituation loanId={loanId} onboardingDetails={onboardingDetails} editModeAllowed={editModeAllowed} />
      <Box mt={3} />
      <ProfessionalDetailsSection
        loanId={loanId}
        agentId={agentId}
        onboardingDetails={onboardingDetails}
        editModeAllowed={editModeAllowed}
      />
    </>
  );
};
